<template>
	<div class="px-4 w-100 position-relative">
		<wrapper-mobile-view>
			<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
				<div class="w-100">
					<div class="row">
						<div class="col-1 align-self-center">
							<div @click="backTo()" class="d-inline-grid">
                <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
              </div>
						</div>
						<div class="col-9 align-self-center">
							<p class="mb-0 body-1-2">{{$t('general.change-language')}}</p>
						</div>
					</div>
				</div>
			</div>
		</wrapper-mobile-view>
		<block :height="57" />
		<div class="my-4">
			<div class="py-2" v-for="country in filter_language">
	      <label :for="country.iso_code" class="cursor-pointer w-100">
	    		<div class="w-100">
	    			<div class="row slim-grid-row">
	            <div class="col-2 text-center">
	              <img :src="country.image_url" width="35" class="border mt-1 position-relative" style="top: 3px">
	            </div>
	             <div class="col-9">
	               <p class="mb-0 body-1-2 text-14 font-bold">{{country.name}}<span v-if="country.status == 'nonactive'" class="overline ml-2">({{$t('general.available-soon')}})</span></p>
	               <p class="mb-0 body-2 font-regular text-12 text-uppercase">{{country.iso_code}}</p>
	             </div>
	             <div class="col-1 text-right">
	                <input :id="country.iso_code" :disabled="country.status == 'nonactive'" type="radio" class="mt-2" v-model="language.selected" :value="country.iso_code">
	             </div>
	           </div>
	    		</div>  
	      </label>
	    </div>
   	 	<p class="body-2 w-75 mx-auto text-center pt-3" v-if="filter_language.length == 0">{{$t('warning-message.language-not-found')}}</p>
		</div>
		<wrapper-mobile-view fixed_position="bottom">
			<div class="px-4 pt-3 pb-4">
				<button type="button" class="button-primary w-100" @click="changeLanguage()">
	        {{$t('general.done')}}
	      </button>
	    </div>
		</wrapper-mobile-view>
	</div>
</template>
<script>
	import {mapActions,mapGetters} from 'vuex';
	export default{
		data(){
			return{
				language:{
					search: '',
					selected: 'en',
					list: this.getMerchant().language
				},
			}
		},
		computed:{
			filter_language(){
				return this.language.list.filter((item)=>{
					return item.name.toString().toLowerCase().match(this.language.search.toLowerCase())
        			|| item.language.toString().toLowerCase().match(this.language.search.toLowerCase())
				})
			},
		},
		methods:{
			...mapGetters(['getMerchant']),
			...mapActions(['setLanguage']),
			backTo(){
				this.$emit('back')
			},
			changeLanguage(){
				this.setLanguage(this.language.selected)
				window.location.reload();
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/account/ChangeLanguage.vue